export enum ModalQueryParam {
  NOTIFICATIONS = 'notifications',
  CLIENT_NOTIFICATIONS = 'clientNotifications',
  CHANGE_PASSWORD = 'changePassword',
  CHANGE_USER_PASSWORD = 'changeUserPassword',
  FARES = 'fares',
  HOLIDAY_CALENDARS = 'holidayCalendars',
  USER_BOOKINGS = 'userBookings',
  ACTIVE_PASSES = 'activePasses',
  FAVOURITE_ROUTES = 'favouriteRoutes',
  DOCUMENTS = 'documents',
  MESSAGE_DETAIL = 'messageDetail',
  CONVERSATION = 'conversation',
}
